module.exports = __webpack_public_path__ + "img/brand_55.ebf99803.png";